// import { Button } from 'rsuite';
import { useUser } from '../../contexts/user';
import DoctorVisitsImage from '../../assets/icons/get_doctor_visit.svg';
import { FofLogin } from '../../components/basic/fof-login';
import { useQuery } from 'react-query';
import { IMAGE_BASE_URL, getExpertise } from '../../core';
import { ExpertyModel } from '../../models/models';
import { CustomLoader } from '../../components/basic/loader';
import { useNavigate } from 'react-router-dom';
export const Booking = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const expertise = useQuery({
    queryKey: ['expertise'],
    queryFn: async () => {
      const res = await getExpertise();
      return res.data.expertise;
    }
  });
  return (
    <>
      {user.isLoggedIn ? (
        <div className="px-5 pt-5 pb-5 text-base1 text-justify bg-[--rs-gray-50] h-full">
          <p
            style={{ lineHeight: '175%', textAlignLast: 'center' }}
            className="mb-4 w-[90%] mx-auto">
            یک زمینه تخصصی را جهت مشاهده پزشکان انتخاب کنید
          </p>
          {expertise.isLoading ? (
            <CustomLoader />
          ) : (
            <>
              {expertise.data.map((experty: ExpertyModel) => {
                return (
                  <div
                    key={experty.id.toString()}
                    onClick={() => navigate(`/expertise/${experty.id}`)}
                    className="flex justify-between shadow-[0_1px_3px_0px_rgba(0,0,0,0.1)] p-2 mb-3 rounded-md bg-[--rs-white] cursor-pointer">
                    <img
                      className="w-[33%]"
                      src={`${IMAGE_BASE_URL}/${experty.expertise_index_image}`}
                      alt={experty.expertise_name}
                    />
                    <div className="w-[67%] flex flex-col text-center text-sm justify-between px-2">
                      <div className="mt-2.5 text-base1">{experty.expertise_name}</div>
                      <div className="mb-2.5 text-sm">{experty.expertise_description}</div>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      ) : (
        <FofLogin
          startFromTop={true}
          image={DoctorVisitsImage}
          text="در این قسمت شما میتوانید از بین تخصص های مختلف پزشکان هر دسته را مشاهده کنید و پس از انتخاب تاریخ ویزیت، اگر در آن روز نوبت ویزیت خالی وجود داشته باشد اقدام به گرفتن نوبت حضوری کنید."
          redirect="/expertise"
        />
      )}
    </>
  );
};
